import GeminiScrollbar from 'gemini-scrollbar';
import 'gemini-scrollbar/gemini-scrollbar.css';

import { editModeSelector } from '../../selectors/settings';

export default class WidgetsLibraryController {
    static $inject = ['$ngRedux','SettingsActions', '$element', '$timeout', '$scope', 'gridHelpers'];
    constructor($ngRedux, SettingsActions, $element, $timeout, $scope, gridHelpers) {
        'ngInject';
        this.$ngRedux = $ngRedux;
        this.unsubscribe = this.$ngRedux.connect(mapStateToThis, SettingsActions)(this);
        this.$element = $element;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.sections = ['main', 'leadTime', 'changeVolume', 'deploymentFrequency'];
        this.gridHelpers = gridHelpers;
    }

    $onInit() {
        this.$timeout(() => {
            this.scrollbar = new GeminiScrollbar({
                element: this.$element[0].querySelector('.wl-body'),
                autoshow: true
            }).create();
        });
        this.sizes = {};
        this.sections.forEach(s => {
            this.sizes[s] = this.gridHelpers.getWidthOfWidget(s, this.settings);
        });
        this.addedSections = [];
    }

    $onDestroy() {
        this.unsubscribe();
        this.scrollbar.destroy();
    }

    toggleSection(name) {
        this.toggleItem(name);
        if (this.settings[name].display === 'all') {
            // calculate new position (row);
            const visibleWidgets = this.sections
                .filter(s => s !== name && ((this.settings[s].display && this.settings[s].display !== 'none') || this.settings[s].visible));
            const rows = visibleWidgets.map(w => this.settings[w].position.row + (w === 'main' ? 1 : 3));
            this.settings[name].position = {
                row: rows.length === 0 ? 0 : Math.max(...rows),
                column: 0
            };
        }
        this.toggleWidgetDisplayType(name);
    }

    toggleWidgetDisplayType(name) {
        this.sizes[name] = this.gridHelpers.getWidthOfWidget(name, this.settings);
    }

    toggleItem(name) {
        const setting = this.settings[name];
        if (setting.display) {
            setting.display = setting.display === 'none' ? 'all' : 'none';
        } else if (setting.visible !== undefined) {
            setting.visible = !setting.visible
            setting.position.column = 0;
        }
        if (setting.display === 'all' || setting.visible) {
            this.addedSections.push(name);
        } else if (this.addedSections.indexOf(name) !== -1) {
            this.addedSections.splice(this.addedSections.indexOf(name), 1);
        }
    }

    cancel() {
        this.modalInstance.dismiss();
    }

    apply() {
        const updatedSettings = this.gridHelpers.adjustPositions(this.settings, this.addedSections);
        if (!updatedSettings.activities.visible) {
            updatedSettings.activities.size = {
                width: 3,
                height: 2
            };
        }
        this.saveChanges(updatedSettings, this.editMode).then(() => {
            this.modalInstance.close();
        });
        this.addedSections = [];
    }
}

function mapStateToThis(state) {
    const obj = { editMode: editModeSelector(state) };
    obj.settings = state.newdashboard.settings.get(obj.editMode ? 'editable' : 'actual').toJS();
    return obj;
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets-library/widgets-library.controller.js